export enum PermissionsSocialPagesEnum {
  Networks = 1,
  NetworkGroups = 7,
  Posts = 10,
  Reports = 13,
}
